import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {TriggerWithConditions} from '../ruleTriggerHelpers';
import {EditorStateActions} from './hooks/useEditorState';
import {RuleAddCard} from './ruleAddCard';
import {OrLabel} from './ruleEditorCommons';
import {RuleTriggersPicker} from './ruleTriggersPicker';

/*
 * Types.
 */

interface RuleTriggerAddBlockProps {
  selectedTriggers: ReadonlyArray<TriggerWithConditions>;

  onAddTrigger: EditorStateActions['onAddTrigger'];
}

/*
 * Component.
 */

export const RuleTriggerAddBlock: FC<RuleTriggerAddBlockProps> = ({selectedTriggers, onAddTrigger}) => (
  <>
    {maybeRenderOrLabel(selectedTriggers)}
    <RuleTriggersPicker selectedTriggers={selectedTriggers} onAddTrigger={onAddTrigger}>
      <RuleAddCard label={<Trans id="rule-editor-trigger-add">Trigger</Trans>} />
    </RuleTriggersPicker>
  </>
);

/*
 * Helpers.
 */

function maybeRenderOrLabel(triggers: ReadonlyArray<TriggerWithConditions>) {
  const shouldDisplayOr = triggers.length > 0;

  if (!shouldDisplayOr) {
    return null;
  }

  return <OrLabel />;
}
